import { Navigate } from "react-router"

import { isSignedIn } from "@/lib/auth-session"
import { postAuthLandingPath } from "@/lib/post-auth-landing"

export function FirstRunRedirect() {
  if (!isSignedIn()) {
    return <Navigate to="/login" replace />
  }
  return <Navigate to={postAuthLandingPath()} replace />
}
